import equal from 'fast-deep-equal'
import { writable } from 'svelte/store'

import { browser } from '$app/environment'
import { makeAccount } from '$lib/factories'
import type { Account } from '$lib/types/client_types'

const store = writable(makeAccount())
export { store as account }

export const ACCOUNT_TEST_INV_CY_ID = '4eXAexVhBRfKSBolwAgtEqNwlY23'

let previousAccount: Account
store.subscribe((account) => {
	if (!browser) return

	if (equal(account, previousAccount)) {
		return
	}

	previousAccount = account

	// set GTM Data Layer variables
	gtmDataLayerPush(account)
})

// set GTM Data Layer variables
export async function gtmDataLayerPush(account: Account | null) {
	if (!browser) return

	if (!account || !account.registered) {
		// console.log('intercom - Account not registered', account)
		return
	}

	// if (account.name === '') {
	// 	return
	// }
	// console.log('gtmDataLayerPush #1')

	// const name = account.name === '' ? account.email : account.name
	const name = account.name // === '' ? account.email : account.name

	window.dataLayer = window.dataLayer || []
	window.dataLayer.push({
		account_id: account.id,
		account_name: name,
		account_email: account.email,
		account_phone: account.phone,
		account_created_at: account.created_at,
		account_created_at_timestamp: account.created_at_timestamp,
		account_registered_at: account.registered_at,
		account_registered_at_timestamp: account.registered_at_timestamp,
		account_subscribed: account.subscribed,
		intercom_account_hash: account.intercom_account_hash
	})
}

